import React from "react";
import { Link } from "react-router-dom";
import { Bot, CheckCircle2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const AEOGEOSection = ({ onOpenPopup }) => {
  return (
    <section className="section-padding relative overflow-hidden" data-testid="aeo-geo-section">
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1920&h=1080&fit=crop"
          alt="AI Technology"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/95 to-black/90" />
      </div>

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#6366F1]/30 bg-[#6366F1]/10">
              <Bot className="w-4 h-4 text-[#6366F1]" />
              <span className="text-sm text-[#6366F1] font-medium">AI-Powered SEO</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold">
              Ready for the <span className="text-[#00E676]">AI Search Revolution?</span>
            </h2>

            <p className="text-lg text-gray-400">
              40% of Gen Z prefers AI search over Google. ChatGPT has 100M+ weekly users. 
              Is your Dallas business optimized for this new reality?
            </p>

            <div className="space-y-4">
              {[
                "Answer Engine Optimization (AEO) - Get featured in AI assistants",
                "Generative Engine Optimization (GEO) - Get cited by ChatGPT & Perplexity",
                "LLM Schema Markup - Help AI understand your content",
                "Voice Search Optimization - Dominate Siri, Alexa & Google Assistant"
              ].map((feature, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#00E676] mt-1 shrink-0" />
                  <span className="text-gray-300">{feature}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                className="btn-ninja"
                onClick={() => onOpenPopup('ebook')}
                data-testid="aeo-download-btn"
              >
                <Download className="w-5 h-5 mr-2" />
                Get 2026 AEO & GEO Guide
              </Button>
              <Link to="/aeo-geo">
                <Button className="btn-outline" data-testid="learn-aeo-btn">
                  Learn About AEO & GEO
                </Button>
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="glass rounded-2xl p-8 space-y-6">
              <h3 className="text-2xl font-bold">Free AEO Audit Includes:</h3>
              <ul className="space-y-4">
                {[
                  "AI Search Visibility Analysis",
                  "Voice Search Compatibility Check",
                  "Schema Markup Review",
                  "Competitor AI Presence Audit",
                  "Custom AEO/GEO Strategy Recommendations"
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-[#00E676]/20 flex items-center justify-center">
                      <CheckCircle2 className="w-4 h-4 text-[#00E676]" />
                    </div>
                    <span className="text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact">
                <Button className="btn-ninja w-full mt-4" data-testid="get-aeo-audit-btn">
                  Get Your Free AEO Audit
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AEOGEOSection;
